import './DiscountExport.scss';
import Component from './DiscountExport.js';
export default Component;
